/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import './styles.less';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';
import { OrdersCustomModalCell } from '../order-custom-modal-cell';
import { CustomLoader } from '../../../../components/custom-loader';
import { SINGLE_COLUMN_ROWS } from '../../constants';

const OrderTableComponent = ({ isTableDataLoading, rows, columns }) => {
	if (isTableDataLoading) {
		return <CustomLoader />;
	}

	return (
		<div className="order-table">
			<Table basic="very" className="order-table__table">
				<Table.Body>
					{!rows.length && (
						<Table.Row>
							<Table.Cell className="order-table__no-data">Данные не найдены</Table.Cell>
						</Table.Row>
					)}
					{rows?.map(row => {
						if (row.group) {
							return (
								<Table.Row key={row.group} className="order-table__table-group-title">
									<Table.Cell colSpan="3">{row.group}</Table.Cell>
								</Table.Row>
							);
						}

						if (SINGLE_COLUMN_ROWS.includes(row.id)) {
							return (
								<Table.Row key={row.id} className="order-table__table-row">
									<Table.Cell className="order-table__table-cell" key={`${row.id}title`}>
										{row.title}
									</Table.Cell>
									<Table.Cell colSpan="2" key={`${row.id}value`} className="order-table__table-cell">
										<OrdersCustomModalCell rowData={row} columnId="value" />
									</Table.Cell>
								</Table.Row>
							);
						}

						return (
							<Table.Row key={row.id} className="order-table__table-row">
								{columns.map(({ id, width, customComponent: CustomComponent, ...columnData }) => {
									if (CustomComponent) {
										return (
											<Table.Cell key={id} className="order-table__table-cell" style={{ width }}>
												<CustomComponent rowData={row} columnId={id} columnData={columnData} />
											</Table.Cell>
										);
									}

									return (
										<Table.Cell className="order-table__table-cell" key={id} style={{ width }}>
											{row[id]}
										</Table.Cell>
									);
								})}
							</Table.Row>
						);
					})}
				</Table.Body>
			</Table>
		</div>
	);
};

OrderTableComponent.propTypes = {
	isTableDataLoading: PropTypes.bool.isRequired,
	columns: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			customComponent: PropTypes.elementType,
		}),
	),
	rows: PropTypes.arrayOf(
		PropTypes.objectOf(
			PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array, PropTypes.number]),
		),
	),
};

export { OrderTableComponent };
